import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { SkipBack } from "lucide-react";
import Formvalidators from "./validators/Formvalidators";

const CorporateQueryForm =  () => {
  let [data, setData]= useState({
    name: '',
    email: '',
    phone: '',
    tentativeDate: '',
    eventType: '',
    numberOfGuests: '',
    estimatedRooms: '',
    eventDescription: '',
    companyName: ''
  })
  let navigate = useNavigate()
 let [show,setShow]=useState(false)
  const [errorMessage, setErrorMessage]= useState({
    name: 'Name Field Is required ',
    email: 'Email Field Is Required',
    phone: 'Phone Field Is Required',
    tentativeDate: 'Tentative date Field Is Required',
    eventType: ' Event Type Field Is Required',
    numberOfGuests: 'Guest Field Is Required',
  
  })

const inputData = (e) => {
  let { name, value } = e.target;
console.log(e.target.name,":",e.target.value);

  
  setData((old) => ({
    ...old,
    [name]: value
  }));

  // Only update error message for required fields
  if (
    name === "name" ||
    name === "email" ||
    name === "tentativeDate" ||
    name === "eventType" ||
    name === "phone" ||
    name === "eventDescription" ||
    name === "phonecompanyName" ||
    name === "estimatedRooms" ||
    name === "numberOfGuests"
  ) {
    setErrorMessage((old) => ({
      ...old,
      [name]: Formvalidators(e)
    }));
  }
};

  const clickme = async(e)=>{
    console.log(data);
    e.preventDefault();
    try {
      let error = Object.values(errorMessage).find((x)=> x.length>0)
      if(error){
        setShow(true)
      }
      else{
        let res =await fetch("http://34.228.14.188:8000/api/corporate-query",{
          method:"POST",
          headers:{
            "Content-type":"application/json"
          },
          body: JSON.stringify(data)
        })
        res = await res.json()
        if(res.result==="Done"){
          toast.success("Your Query Has Been Submited !")
          setTimeout(()=>{
            navigate("/")
          },1000)
        } 
        else
        alert("402 ! Internal Server Error")       
      }
    } catch (error) {
      alert("Something Went Wrong ",error)
      
    }
  }
  return (
   <>
   {/* <Navbar2/> */}
   <Toaster
  position="top-center"
  reverseOrder={false}
/>
   <div className="container form-div "  style={{background:"rgb(255, 255, 255)"}}>
        <div className="containar-fluid "  style={{background:"rgb(255, 255, 255)"}}>
        <h2 className="text-center mb-4" style={{color:"#AD8B3A"}}> Corporate Enquiry </h2>
        <form className="mx-auto" style={{ maxWidth: "1000px" }} onSubmit={clickme}>
      <div className="row">
      <div className="col-md-4 mb-3">
                <input onChange={inputData} type="text" name="name" placeholder="Name*" className="form-control custom-input" />
          {show && errorMessage ?<sup className="text-danger">{errorMessage.name}</sup>:""}
          </div>
        {/* {show && errorMessage ? <p> {errorMessage.name}</p>:""} */}
        <div className="col-md-4 mb-3">
          <input
            type="email"
            name="email"
            placeholder="Email*"
            className="form-control custom-input"
            onChange={inputData}
           
          />
          {show && errorMessage ?<sup className="text-danger">{errorMessage.tentativeDate}</sup>:""}

        </div>
        <div className="col-md-4 mb-3">
          <input
            type="number"
            name="phone"
            placeholder="Mobile Number*"
            className="form-control custom-input"
            onChange={inputData}
           
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-4 mb-3">
          <label className="form-label custom-input">Tentative Date*</label>
          <input
            type="date"
            name="tentativeDate"
            className="form-control custom-input"
            onChange={inputData}
           
          />
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label custom-input">Event Type*</label>
          <select
            name="eventType"
            className="form-control custom-input"
            onChange={inputData}
           
          >
            <option value="">Select &#11163;</option>
            <option>Corporate</option>
            <option>Events</option>
            <option>Meeting</option>
            <option>Business</option>
            <option>Other</option>
          </select>
        </div>
        <div className="col-md-4 mb-3">
          <label className="form-label custom-input">Number Of Guests*</label>
          <select
            name="numberOfGuests"
            className="form-control custom-input"
            onChange={inputData}
            required
          >
            <option value="">Select &#11163;</option>
            <option>Up to 10</option>
            <option>11-25</option>
            <option>26-50</option>
            <option>51-100</option>
            <option>101-200</option>
            <option>Other</option>
          </select>
        </div>
      </div>

      <div className="row mb-3">
        <div className="form-check col-md-4 mb-3">
          {/* <input
            className="form-check-input mx-1 me-2"
            type="checkbox"
            id="requireRooms"
            name="requireRooms"
            onChange={inputData}
          /> */}
          <label className="form-check-label" htmlFor="requireRooms">
            Do you require rooms?
          </label>
        </div>
        <div className="col-md-8 mb-3">
          <input
            type="number"
            name="estimatedRooms"
            placeholder="Estimated Number of Rooms"
            className="form-control custom-input"
            onChange={inputData}
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-12 mb-3">
          <textarea
            name="eventDescription"
            placeholder="Briefly Describe Your Event Requirements"
            className="form-control custom-input"
            rows="4"
            onChange={inputData}
          ></textarea>
        </div>
      </div>

      <div className="row mb-3">
        <div className="form-check col-md-4 mb-3">
          {/* <input
            className="form-check-input mx-1 me-2"
            type="checkbox"
            id="corporateQuery"
            name="isCorporateQuery"
            onChange={inputData}
          /> */}
          <label className="form-check-label" htmlFor="corporateQuery">
            Is this a corporate query?
          </label>
        </div>
        <div className="col-md-8 mb-3">
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            className="form-control custom-input"
            onChange={inputData}
          />
        </div>
      </div>

      <div className="form-btn">
        <button type="submit" className="btn btn-primary">Submit</button>
      </div>
    </form>
          <Link to="/corporate" className="coprporate-query-back-btn"> <SkipBack  /></Link>

      
         
                <p className="text-center  form-para" >You may also contact us email info@thegrandshobha.com</p>
          
        
        </div>
    </div>
    
   </>
  );
};

export default CorporateQueryForm;